import {Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Address} from 'cluster';
import {AddOrderTransmissionService} from 'src/app/raintree/transmission/order-transmission/order-transmission.service';
import {RequestMapperService} from 'src/app/request-mapper.service';
import {ToastMessageService} from 'src/app/services/toast-message.service';
import {OrderDetails} from "../interface/order-details";
import {OrderedItem} from "../interface/ordered-item";
import {StoreForexService} from "../../navigation/service/store-forex.service";
import {OrderService} from '../service/order.service';
import {CustomSize} from 'src/app/cart/interface/custom-size';
import {SelectedFinishProfileItem} from '../interface/selected-finish-profile-item';
import {PrepareRemainingPaymentService} from '../service/prepare-remaining-payment.service';
import {isPlatformBrowser} from '@angular/common';
import {OrderFeedbackTransmissionService} from "../../raintree/transmission/order-feedback-transmission.service";
import {OrderFeedback} from "../interface/order-feedback";
import {IOrderConversionData} from "../interface/order-conversion-data";
import {OrderCancellationDialogComponent} from "../order-cancellation-dialog/order-cancellation-dialog.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
	selector: 'fb-profile-order',
	templateUrl: './profile-order.component.html',
	styleUrls: ['./profile-order.component.scss']
})
export class ProfileOrderComponent implements OnInit {

	@Input()
	public showHeader: boolean = true;

	@Output()
	public conversionData: EventEmitter<IOrderConversionData> = new EventEmitter();

	private _today: number = new Date().getTime();
	private _msIn24Hours = 24 * 60 * 60 * 1000;

	public orderDetails: OrderDetails | null = null;
	public orderId: number = -1;
	public reviewOrderItemId: number = -1;
	public orderItemId: number = -1;
	public pageLoad = false;
	public inStockOrederItem: OrderedItem[] = [];
	public madeToOrederItem: OrderedItem[] = [];
	public preOrederItem: OrderedItem[] = [];
	public isBrowser: boolean = false;
	public showRemainingPayButton: boolean = false;
	public showOrderInformation: boolean = false;
	public showFeedbackBtn: boolean = false;
	public hideCancelButton: boolean = false;
	public showFeedbackToast: boolean = false;
	public feedbackComplete: boolean = false;
	public isLoading: boolean = true;
	public orderFeedback: OrderFeedback | null = null;
	public sortOrderSection: string[] = [];

	constructor(
		public _toast: ToastMessageService,
		private _orderTransmision: AddOrderTransmissionService,
		private _orderFeedbackApi: OrderFeedbackTransmissionService,
		private _route: ActivatedRoute,
		public storeForex: StoreForexService,
		private _router: Router,
		private _dialog: MatDialog,
		private _prepareRemainingPayment: PrepareRemainingPaymentService,
		@Inject(PLATFORM_ID) private _platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	}

	public ngOnInit(): void {

		this._route.params.subscribe(params => {
			this.getOrderDetails(params['id']);
			this.orderId = params['id'];
		});

		this._route.queryParams.subscribe(params => {
			this.reviewOrderItemId = params['review'];
			this.orderItemId = +params['item'];
		});
	}

	public getOrderDetails(id: string) {
		this._orderTransmision.orderGetById(
			RequestMapperService.GET_BY_ID_ORDER + id,
			() => {
				//success
			},
			() => {
				//error
			},
			(response: OrderDetails) => {
				this.hideCancelButton = (this._today - response.createdAt > this._msIn24Hours);
				this.getOrderFeedbackDetails(+id);
				this.orderDetails = response;
				this.sortByOrderType();

				this.conversionData.emit({
					orderId: this.orderDetails.id,
					currency: this.orderDetails.currency,
					value: this.orderDetails.total,
					items: this.orderDetails.orderItems.map(item => {
						return {
							item_name: item.customization.fabricProductPreview? item.customization.fabricProductPreview.product.name: (item.customization.finishedProductPreview? item.customization.finishedProductPreview.product.name : ''),
							item_id: item.customization.fabricProductPreview? item.customization.fabricProductPreview.product.sku: (item.customization.finishedProductPreview? item.customization.finishedProductPreview.product.sku : ''),
							price: item.price,
							quantity: item.quantity
						}
					})
				});
			},
			() => {
			},
			() => {
			}
		)
	}

	public getOrderFeedbackDetails(id: number) {
		this._orderFeedbackApi.getOrderFeedbackByOrderId(
			id,
			() => {
				//success
			},
			() => {
				//error
			},
			(response: OrderFeedback) => {
				this.orderFeedback = response;
				if (this.orderFeedback.question1Answer > 0 && this.orderFeedback.question2 && this.orderFeedback.question3Answer) {
					this.showFeedbackBtn = false;
					this.showFeedbackToast = false;
				} else {
					this.showFeedbackBtn = true;
				}

			},
			() => {
				setTimeout(() => {
					this.showFeedbackToast = true;
				}, 1000);
				this.showFeedbackBtn = false;
			},
			() => {
				this.isLoading = false;
			}
		)
	}

	public onFeedbackClose(): void {
		this.showFeedbackToast = false;
		this.getOrderFeedbackDetails(this.orderId);
	}

	public sortByOrderType(): void {

		if (!this.orderDetails) return;

		this.orderDetails.orderItems.sort((a, b) => b.updatedAt - a.updatedAt);
		this.orderDetails.orderItems.forEach((elm: OrderedItem) => {
			if(!this.sortOrderSection.includes(elm.orderType)) {
				this.sortOrderSection.push(elm.orderType);
			}
			if (elm.orderType === 'IN_STOCK') {
				this.inStockOrederItem.push(elm);
			}
			if (elm.orderType === 'MADE_TO_ORDER') {
				this.madeToOrederItem.push(elm);
			}
			if (elm.orderType === 'PRE_ORDER') {
				this.preOrederItem.push(elm);
			}
		});

		if (this.preOrederItem && this.preOrederItem.length > 0) {
			this.preOrederItem.forEach((elm: OrderedItem) => {
				if (elm.preOrderReady) {
					this.showRemainingPayButton = elm.preOrderReady;
					return;
				}
			})
		}
		this.pageLoad = true;
		if (this.isBrowser) {
			if (window.location.href.includes('pre-order-payment=true')) {

				setTimeout(() => {
					document.getElementById("remaining_pay_cont")!.scrollIntoView({behavior: 'smooth'})
				}, 1000)
			}
		}


	}

	public hasProp(o: Address, name: string): boolean {
		return o.hasOwnProperty(name);
	}

	public cancelOrder(orderId: number): void {
		this._dialog.open(OrderCancellationDialogComponent, {
			data: { orderId: orderId },
			maxWidth: '80vw',
			maxHeight: '90vh'
		});
	}

	public navigate(
		orderedItem: OrderedItem,
	): void {


		let slug = orderedItem.customization.fabricProductPreview ? 'fabric-product/' + orderedItem.customization.fabricProductPreview.product.slug :
			'finished-product/' + orderedItem.customization.finishedProductPreview!.product.slug;

		this._router.navigate(['../../product/' + slug])
	}

	public prepareCustomSizeLabel(customSizeData: CustomSize): string {

		let listOfLabel: string[] = [];
		let label: string = '';

		for (const [key, value] of Object.entries(customSizeData)) {
			// console.log(key, value);
			listOfLabel.push(`${key}: ${value}`);
		}

		label = listOfLabel.join();

		return label;
	}

	public prepareFinishLabel(selectedFinishItems: SelectedFinishProfileItem[]): string {

		let listOfLabel: string[] = [];
		let label: string = '';

		selectedFinishItems.forEach((selectedFinishItems: SelectedFinishProfileItem) => {
			listOfLabel.push(selectedFinishItems.label);
		});

		label = listOfLabel.join();

		return label
	}

	public remainingPay(): void {
		this._prepareRemainingPayment.prepareRemainingPayment(
			this.orderDetails ? this.orderDetails : {} as OrderDetails
		);
	}

	protected readonly locationbar = locationbar;
}
